export default __webpack_public_path__ + "static/media/google-play.290ad259.svg";